import React from 'react'
import { Row, Col, Collapse, CardBody } from "reactstrap";
import '../WorksheetDetails.css'

const ResponsiveWorksheetDetails = (props) => {
    return (
        <div className='responsive-Worksheet-Details'>
            <div className='save-buttons'>
                <button className='button'>SAVE</button>
                <button className='button'>DOWNLOAD</button>
            </div>

            <div className='shared-details'>
                <Row>
                    <Col className='shared-by'>Shared By:</Col>
                    <Col>{props.InputFields.shared_by}</Col>
                </Row>
                <hr />
                {props.sharedWith.shared_with_list && props.sharedWith.shared_with_list.map((sharedList, index) => {
                    return (
                        <div key={index}>
                            <Row className='shared-with' onClick={() => props.toggleCollapse(sharedList.id)}>Shared With
                                <i className={props.collapseID === sharedList.id ? "fas fa-angle-up" : "fa fa-angle-down"} aria-hidden="true" />
                            </Row>
                            <Collapse isOpen={props.collapseID === sharedList.id}>
                                <CardBody>
                                    <Row><span className='number'>{index + 1}</span>.{sharedList.shared_to__email}</Row>
                                </CardBody>
                                <hr />
                            </Collapse>
                        </div>
                    )
                })}
            </div>
            <h6 className='note-head'>Note</h6>
            <p className='note'>
                <span className='note-data'>{props.Note.weak_attribute}</span> is your weak area in
                <span className='note-data'>{props.Note.orientation}</span>.
                You may want to seek inputs from your
                {props.Note.assessor_groups && props.Note.assessor_groups.map((relation, index) => {
                    return (
                        <span key={index} className='relaton'>{relation.assessor_name},</span>
                    )
                })} when filling out that area below.
            </p>

            {props.InputFields.worksheet_goal && props.InputFields.worksheet_goal.map((data, index) => {
                return (
                    <div key={index}>
                        <p className='heading'><span className='number'>{index + 1}</span>.{data.attribute__attribute_name}</p>
                        <textarea placeholder={data.attribute__attribute_name} className='input-area' />
                    </div>
                )
            })}
        </div>
    )
}

export default ResponsiveWorksheetDetails



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/WorksheetDetails/Responsive/Worksheet-Details.jsx